import { DataType } from "./AnalyticsTracker";
import {
	BING_REQUIRES_CONSENT,
	isAnalyticsConsentSatisfied,
} from "./cookieConsentConfig";

export class BingUETProvider {
	private isBingEnabled(): boolean {
		return WEBPACK_ANALYTICS_PROVIDERS.includes("bing-web");
	}

	private hasConsent(): boolean {
		return isAnalyticsConsentSatisfied(BING_REQUIRES_CONSENT, "ads");
	}

	constructor() {}

	public trackEvent(eventName: string, data: DataType) {
		if (!this.isBingEnabled()) {
			return;
		}

		if (!this.hasConsent()) {
			return;
		}

		window.uetq?.push("event", eventName, data);
	}
}
